<div class="form-group" [formGroup]="formGroup">
  <select class="select2 form-control custom-select" *ngIf="formField.nested" [formControlName]="formField.key" required
    id="formField.key" name="formField.key">
    <option value="formField.key" disabled hidden>{{formField.label}}</option>

    <optgroup *ngFor="let option of formField.options | async" [label]="option.label">
      <option *ngFor="let children of option.childrens" [value]="children.key || children.id"
        [id]="children.value||children.display_name">{{children.value || children.display_name}}</option>
    </optgroup>
  </select>
  {{formField.label}}
  <select class="select2 form-control custom-select" [ngClass]="{ 'is-invalid': control.errors }"
    *ngIf="!formField.nested" [formControlName]="formField.key">
    <!-- <option value="undefined">{{formField.label}}</option> -->
    <option *ngFor="let option of formField.options | async" [value]="option.key || option.id || option.name "
      [id]="option.value||option.name">{{option.value || option.name}}</option>

  </select>
  <div *ngIf="control.errors" class="invalid-feedback">
    <div *ngIf="control.errors.required" class="invalid-feedback">This is
      required</div>
    <div *ngIf="!control.errors.required" class="invalid-feedback">Invalid {{formField.label}}</div>
  </div>
</div>